<template>
  <div class="filter">
    <component
      :is="componentType"
      v-model="selectedProxy"
      :label="label"
      :options="options"
      :placeholder="placeholder"
      :show-reset="showReset"
      :show-selections="showSelections"
    />
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    modelValue?: string[]
    label?: string
    placeholder?: string
    showSelections?: boolean
    isMultiSelect?: boolean
  }>(),
  {
    modelValue: () => [],
    label: 'I need help with...',
    placeholder: 'Any type of support',
    showSelections: true,
    isMultiSelect: true,
  },
)
const emit = defineEmits(['update:modelValue'])

const { data: serviceTypes } =
  await useStoryblokDataSources().fetchServiceTypes()

const selected = computed({
  get: () => {
    return props.modelValue
  },
  set: (value) => {
    emit('update:modelValue', value)
  },
})

const componentType = computed(() =>
  getFormkitSelectComponentName(props.isMultiSelect),
)
const options = computed(
  () =>
    serviceTypes.value?.map((option) => ({
      label: option.name,
      value: option.value,
    })) || [],
)

const selectedProxy = computed({
  get: () => selected.value,
  set: (value) => {
    emit('update:modelValue', value)
    selected.value = value
  },
})

const showReset = computed(() => props.isMultiSelect)
</script>
